import type { LiveStreamEntries } from '../../types';

import type { IconName } from 'app/design-system/types/Icon';
import type { tFunction } from 'app/lang';
import { getSportKey } from 'app/lib/betting/sport-utils';

import dictionary from './MatchesDropdown.dictionary.json';

export const getSportIconName = (sportId: number): IconName => {
  return `sport-${getSportKey(sportId)}` as IconName;
};

export const getSportName = (entries:LiveStreamEntries, matchId:number, t:tFunction) => {
  return entries.get(matchId)?.sportName || t(dictionary.unknownSport);
};
